import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";

export const ProjectSideAnalytics = ({
  projectExist,
  setChartData,
  chartData,
  setSelectedIndex,
  selectedIndex,setSelectedAlias
}) => {
  const analyticsTabs = projectExist?.analytics?.analytics_activeTab || [];
  const rabiTaskId = projectExist?.analytics?.rabi_task_id;
  const kharifTaskId = projectExist?.analytics?.kharif_task_id;
    const otherSeasonTasks = projectExist?.analytics?.otherSeasonTask || [];

  const [season, setSeason] = useState("");
   const { t, i18n } = useTranslation();
  // console.log("projectExist",projectExist?.analytics)
  useEffect(() => {
    if (kharifTaskId && rabiTaskId) {
      setSeason("Kharif");
    } else if (kharifTaskId) {
      setSeason("Kharif");
    } else if (rabiTaskId) {
      setSeason("Rabi");
    }
     else if (otherSeasonTasks?.length > 0) {
      setSeason(otherSeasonTasks[0].season);
    }
  }, [kharifTaskId, rabiTaskId]);

  const getTaskId = () => {
    if (season === "Kharif") return kharifTaskId;
    if (season === "Rabi") return rabiTaskId;
     const matched = otherSeasonTasks?.find(
      (s) => s.season.toLowerCase() === season.toLowerCase()
    );
    return matched?.taskId || null;
    // return null;
  };

  useEffect(() => {
    // console.log("clock",season)

    const fetchData = async () => {
      // console.log("clock33",season)

      const taskId = getTaskId();
      if (!taskId) return;

      try {
        const response = await axios.get(
          `https://datapipeline-api.agrani.tech/task_details?taskId=${taskId}`
        );
        setChartData(response?.data?.data);
        // console.log("API data:", response?.data?.data);
      } catch (error) {
        console.error("Failed to fetch chart data:", error);
      }
    };

    if (season) {
      // setChartData(null);
      // setSelectedIndex(null);
      // console.log("clock22",chartData)
      fetchData();
    }
  }, [season]);
  useEffect(() => {
  if (analyticsTabs?.length > 0 && analyticsTabs[0]?.indices?.length > 0) {
    const firstIndex = analyticsTabs[0].indices[0];
    setSelectedIndex(firstIndex.name);
    setSelectedAlias(firstIndex.alias);
  }
}, [analyticsTabs]);

  const handleIndexSelect = (value,index) => {
 
    setSelectedIndex(value);
    setSelectedAlias(index.alias)
  };

  const clearFilters = () => {
    setSelectedIndex(null);
    setSelectedAlias(null)
  //   if (analyticsTabs?.length > 0 && analyticsTabs[0]?.indices?.length > 0) {
  //   const firstIndex = analyticsTabs[0].indices[0];
  //   setSelectedIndex(firstIndex.name);
  //   setSelectedAlias(firstIndex.alias);
  // } else {
  //   setSelectedIndex(null);
  //   setSelectedAlias(null);
  // }
  };
  // console.log("chartData", chartData);

  return (
    // <Card>
    //   <CardBody style={{ padding: "1.8rem 2rem" }}>
    //     <div className="d-flex justify-content-between mb-3">
    //       <h5 className="card-title fw-bold text-primary mb-0">
    //         <i className="mdi mdi-filter-variant me-2" />
    //         {t("Analytics")}
    //       </h5>
    //       {selectedIndex && (
    //         <button
    //           className="btn btn-sm p-1 px-2 border text-danger"
    //           onClick={clearFilters}
    //           title="Clear all filters"
    //           style={{
    //             fontSize: "0.85rem",
    //             borderRadius: "6px",
    //             borderColor: "#dc3545",
    //             color: "#dc3545",
    //             backgroundColor: "#fff",
    //           }}
    //         >
    //           {t("Clear")} <i className="mdi mdi-close-circle fs-6" />
    //         </button>
    //       )}
    //     </div>

    //     <div className="mb-3">
    //       <label className="fw-semibold text-secondary">
    //         🌾 {t("Select Season")}:
    //       </label>
    //       <div className="d-flex align-items-center gap-4 mt-2">
    //         {kharifTaskId && (
    //           <>
    //             <input
    //               className="form-check-input"
    //               type="radio"
    //               name="season"
    //               id="seasonKharif"
    //               value="Kharif"
    //               checked={season === "Kharif"}
    //               onChange={(e) => setSeason(e.target.value)}
    //             />
    //             <label className="form-check-label" htmlFor="seasonKharif">
    //               Kharif
    //             </label>
    //           </>
    //         )}
    //         {rabiTaskId && (
    //           <>
    //             <input
    //               className="form-check-input"
    //               type="radio"
    //               name="season"
    //               id="seasonRabi"
    //               value="Rabi"
    //               checked={season === "Rabi"}
    //               onChange={(e) => setSeason(e.target.value)}
    //             />
    //             <label className="form-check-label" htmlFor="seasonRabi">
    //               Rabi
    //             </label>
    //           </>
    //         )}
    //          {otherSeasonTasks&&otherSeasonTasks?.map((task, i) => (
    //           <React.Fragment key={i}>
    //             <input
    //               className="form-check-input"
    //               type="radio"
    //               name="season"
    //               id={`season-${task.season}`}
    //               value={task.season}
    //               checked={season === task.season}
    //               onChange={(e) => setSeason(e.target.value)}
    //             />
    //             <label
    //               className="form-check-label text-capitalize"
    //               htmlFor={`season-${task.season}`}
    //             >
    //               {t(task.season)}
    //                {console.log("apbbb",task.season)}
    //             </label>
    //           </React.Fragment>
    //         ))}
    //       </div>
    //     </div>

    //     {analyticsTabs.map((tab, tabIndex) => (
    //       <div key={tabIndex} className="mb-3">
    //         <h6 className="text-secondary fw-semibold mb-2">{t(tab.alias)}</h6>
    //         {tab?.indices.map((index, indexIdx) => (
    //           <div className="form-check mb-2" key={indexIdx}>
    //             <input
    //               className="form-check-input"
    //               type="radio"
    //               name={`dynamicIndex-${tab.type}`}
    //               id={`${tab.type}-${index.name}`}
    //               value={index.name}
    //               checked={selectedIndex === index.name}
    //               onChange={() => handleIndexSelect(index.name,index)}
    //             />
    //             <label
    //               className="form-check-label"
    //               htmlFor={`${tab.type}-${index.name}`}
    //             >
    //               {t(index.alias)}
    //             </label>
    //           </div>
    //         ))}
    //       </div>
    //     ))}
    //   </CardBody>
    // </Card>
    <Card className="shadow-sm border-0">
  <CardBody className="p-4">

    {/* Header */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="fw-bold text-primary mb-0 d-flex align-items-center">
        <i className="mdi mdi-filter-variant me-2 fs-5" />
        {t("Analytics")}
      </h5>

      {selectedIndex && (
        <button
          className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1"
          onClick={clearFilters}
          style={{ borderRadius: "6px" }}
        >
          {t("Clear")}
          <i className="mdi mdi-close-circle fs-5"></i>
        </button>
      )}
    </div>

    {/* Season Selection */}
    <div className="mb-4">
      <label className="fw-semibold text-secondary">
        🌾 {t("Select Season")}
      </label>

      <div className="d-flex flex-wrap gap-4 mt-2">

        {/* Kharif */}
        {kharifTaskId && (
          <label className="d-flex align-items-center gap-2">
            <input
              className="form-check-input"
              type="radio"
              name="season"
              value="Kharif"
              checked={season === "Kharif"}
              onChange={(e) => setSeason(e.target.value)}
            />
            <span className="fw-medium">{t("Kharif")}</span>
          </label>
        )}

        {/* Rabi */}
        {rabiTaskId && (
          <label className="d-flex align-items-center gap-2">
            <input
              className="form-check-input"
              type="radio"
              name="season"
              value="Rabi"
              checked={season === "Rabi"}
              onChange={(e) => setSeason(e.target.value)}
            />
            <span className="fw-medium">{t("Rabi")}</span>
          </label>
        )}

        {/* Dynamic Seasons */}
        {otherSeasonTasks?.map((task, i) => (
          <label key={i} className="d-flex align-items-center gap-2 text-capitalize">
            <input
              className="form-check-input"
              type="radio"
              name="season"
              value={task.season}
              checked={season === task.season}
              onChange={(e) => setSeason(e.target.value)}
            />
            <span className="fw-medium">{t(task.season)}</span>
          </label>
        ))}

      </div>
    </div>

    {/* Analytics Type Sections */}
    {analyticsTabs.map((tab, idx) => (
      <div key={idx} className="mb-4">
        <h6 className="text-secondary fw-semibold mb-2">
          {t(tab.alias)}
        </h6>

        {tab?.indices.map((index, j) => (
          <label key={j} className="d-flex align-items-center mb-2 gap-2">
            <input
              className="form-check-input"
              type="radio"
              name={`dynamicIndex-${tab.type}`}
              value={index.name}
              checked={selectedIndex === index.name}
              onChange={() => handleIndexSelect(index.name, index)}
            />
            <span>{t(index.alias)}</span>
          </label>
        ))}

        {idx < analyticsTabs.length - 1 && <hr className="my-3" />}
      </div>
    ))}

  </CardBody>
</Card>

  );
};
